"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeModuleType = void 0;
var NativeModuleType;
(function (NativeModuleType) {
    NativeModuleType[NativeModuleType["NONE"] = 0] = "NONE";
    NativeModuleType[NativeModuleType["NODE_GYP"] = 1] = "NODE_GYP";
    NativeModuleType[NativeModuleType["PREBUILD"] = 2] = "PREBUILD";
})(NativeModuleType = exports.NativeModuleType || (exports.NativeModuleType = {}));
//# sourceMappingURL=nativeModuleTypes.js.map